import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookB5Service } from './taf-book-b5.service';
import { ITAFBookB5 } from './taf-book-b5-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-b5/taf-book-b5.component.html',
     template: require('./taf-book-b5.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookB5Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK b5';
    errorMessage: string;
    tafBookB5Arr: ITAFBookB5;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookB5Service: TAFBookB5Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookB5Service.getTAFBookB5()
         .subscribe(
                tafBookB5Arr => this.tafBookB5Arr = tafBookB5Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}



/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b5/taf-book-b5.component.ts
 **/